export const SITE_NAME = process.env.VUE_APP_SITE_NAME
export const SITE_SLUG = process.env.VUE_APP_SITE_SLUG
export const THEME_NAME = process.env.VUE_APP_THEME_NAME || 'RestoTheme'
